<template lang="pug">
    .slide(v-if="image")
      Picture(
        :image="image"
        :show-placeholder="false"
        :show-dlaceholder="false"
        :show-spinner="false"
        :max-width="maxWidth"
        :max-height="maxHeight"
        :optimize="optimize"
        :lazy="true"
        missing-icon="exclamation-triangle"
        object-fit="cover"
        title="slide"
        alt="slide"
      )
        .content(v-if="slide.title || slide.sub_title || slide.text" ref="content")
          h2(v-if="slide.title") {{ slide.title }}
          h4(v-if="slide.sub_title") {{ slide.sub_title }}
          .text(v-if="slide.text" v-html="slide.text")
          router-link.more-link(
            v-if="path"
            :to="path"
          )
            | {{ linkText }}
          component.more-link(
            v-else-if="href"
            :is="tag"
            v-bind="props"
          )
            | {{ linkText }}
</template>

<script>
import { get, trim } from '@/helpers';

export default {
  name: 'Slide',
  data() {
    return {
      delay: 0,
      mouseover: false
    };
  },
  props: {
    slide: {
      type: Object,
      required: true
    },
    maxWidth: {
      type: Number,
      required: true
    },
    maxHeight: {
      type: Number,
      required: true
    },
    optimize: {
      // if speed is selected, get only prerendered variants if possible
      type: String,
      default: 'speed',
      validator: val => ['speed', 'traffic'].includes(val)
    }
  },
  computed: {
    image() {
      return get(this.slide, 'images.0');
    },
    tag() {
      let tag = 'div';
      if (this.path) tag = 'router-link';
      else if (this.href) tag = 'a';
      return tag;
    },
    props() {
      let props = {};

      switch (this.tag) {
        case 'router-link':
          props.to = this.path;
          break;

        case 'a':
          props.title = this.slide.title || this.slide.sub_title;
          props.href = this.href;
          props.target = this.target;
          break;
      }

      return props;
    },
    hyperlink() {
      return get(this.slide, 'hyperlink') || {};
    },
    href() {
      let href = false;

      if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
        const link = this.hyperlink.href;
        switch (this.hyperlink.type) {
          case 'external':
            if (!link.startsWith('https://') && !link.startsWith('http://')) href = `https://${link}`;
            else href = link;
            break;

          case 'mailto':
            href = `mailto:${link}`;
            break;

          case 'tel':
            href = `tel:${link}`;
            break;
        }
      }

      return href;
    },
    target() {
      return get(this.hyperlink, 'target') || '_self';
    },
    path() {
      if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
        return this.hyperlink.menuItem.path;
      else return false;
    },
    linkText() {
      return get(this.hyperlink, 'name') || 'mehr...';
    },
    style() {
      let style = {};

      if (this.slide.color) {
        style.background = this.slide.color;
      }

      return style;
    }
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.slide
  @apply flex justify-center items-center

.picture-container
  @apply top-0 left-0 w-full h-full
  position: absolute !important

.content
  width: 400px
  text-decoration: none
  max-width: calc(100vw - 2rem)
  padding: .8rem 1.6rem
  background: rgba($black, .4)
  backdrop-filter: blur(10px)
  border-radius: .4rem
  color: $white
  margin-top: 1rem
  margin-bottom: 1rem
  @screen md
    width: 600px
  @screen xl
    width: 800px
  h2
    font-size: 1.4rem
    font-weight: 600
    @screen md
      font-size: 1.8rem
      font-weight: 500
  h4
    font-weight: 600
    @screen md
      font-size: 1.2rem
      font-weight: 500
  a
    color: theme('colors.blue.300')
  .text
    margin-top: .8rem
</style>
